/**
 * @fileoverview Header component.core
 *
 */
'use strict';
// React Import
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
// Library Import
import _ from 'lodash';
import mobiscroll from '../../lib/mobiscroll/forms.react';
import '../../lib/mobiscroll/navigation.react';
// Core Import
import Loading from './Loading';
import Menu from '../core/Menu';
// Conection Import
import AuthCollection from '../../collection/AuthCollection';
// Util Import
import * as ConstUtil from '../../util/ConstUtil';

/**
 * ヘッダーコンポーネント
 *
 * @class Header
 * @extends {Component}
 */
class Header extends Component {
  constructor(props) {
    super(props);
    this.collection = new AuthCollection();
    _.bindAll(
      this,
      // 'clickHamburgerMenu',
      'clickMyPageButton',
      'getRefHeader',
      'clickLogout'
    );
  }

  /**
   * Component 更新前処理
   *
   * @memberof Header
   */
  componentDidUpdate() {
    this.props.setHeight(this.refHeader.offsetHeight);
  }
  /**
   * ボタンクリック
   *
   * @memberof CenterHeader
   */
  clickMyPageButton() {
    this.props.history.push(ConstUtil.Common.COMPONENT.ACCOUNT.URL);
  }
  /**
   * ログアウトボタンクリック時
   *
   * @memberof Header
   */
  clickLogout() {
    Loading.show();
    this.collection.logout(
      {
        success: this.successLogout.bind(this),
        failure: this.failureLogout.bind(this)
      },
      {}
    );
  }
  /**
   * ログアウト成功
   *
   * @memberof Header
   */
  successLogout() {
    Loading.hide();
    // ローカルストレージクリア
    localStorage.clear();
    // ログイン画面に遷移
    this.props.history.push(ConstUtil.Common.COMPONENT.LOGIN.URL);
  }
  /**
   * ログアウト失敗
   *
   * @memberof Header
   */
  failureLogout() {
    this.failureCommonCallback;
  }

  /**
   * 共通エラー処理
   *
   * @param {*} err
   * @memberof Header
   */
  failureCommonCallback(err) {
    Loading.hide();
    // エラーメッセージを赤文字に設定
    this.setState({
      messageStyle: ConstUtil.Common.ERROR_AREA_STYLE.DANGER
    });
    // エラーメッセージ表示
    this.showErrorMessage(err);
  }
  /**
   * ボタンエリア要素の描画
   *
   * @returns {Object} ボタンエリア要素
   * @memberof Header
   */
  renderButtonArea() {
    // 未ログインの場合
    if (
      _.isEmpty(localStorage.getItem(ConstUtil.Common.STORAGE_KEY.AUTHORITY_ID))
    ) {
      return;
    }
    if (window.location.hash === ConstUtil.Common.COMPONENT.LOGIN.URL) {
      return;
    }
    // Android と iOSの場合
    // if (os === 'android' || os === 'ios') {
    //   return this.renderHamburgerMenu();
    // }
    return (
      <div className="header-button-area">
        {/* <mobiscroll.Button
          flat={true}
          icon="fa-user"
          color="heddermain"
          onClick={this.clickMyPageButton}
        >
          {ConstUtil.Message.COMMON.MYPAGE}
        </mobiscroll.Button> */}
        <mobiscroll.Button
          flat={true}
          icon="fa-sign-out"
          color="heddermain"
          onClick={this.clickLogout}
        >
          {ConstUtil.Message.COMMON.LOGOUT}
        </mobiscroll.Button>
      </div>
    );
  }
  /**
   * ヘッダーの参照取得
   *
   * @param {Object} node ノード情報
   * @returns
   * @memberof Header
   */
  getRefHeader(node) {
    if (_.isEmpty(node)) {
      return;
    }
    this.refHeader = node;
  }

  /**
   * 描画
   *
   * @returns {Object} 画面を構成する要素
   * @memberof Header
   */
  render() {
    return (
      <header ref={this.getRefHeader}>
        <div className="system-title">{ConstUtil.Message.COMMON.LOGIPULL}</div>
        {this.renderButtonArea()}
        <Menu />
      </header>
    );
  }
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/js/component/core/Header.jsx